import { inject, InjectionToken } from '@angular/core';

import type { Observable } from 'rxjs';

import {
  SkillsIdeateProgressMessage,
  SkillsIdeateProgressTrackService,
} from './skills-ideate-progress-track.service';

export interface SkillsIdeateProgressTracker {
  track: (ideateId: number) => Observable<SkillsIdeateProgressMessage>;
}

export const SKILLS_IDEATE_PROGRESS_TRACKER = new InjectionToken<SkillsIdeateProgressTracker>(
  'SKILLS_IDEATE_PROGRESS_TRACKER',
  {
    providedIn: 'root',
    factory: () => inject(SkillsIdeateProgressTrackService),
  },
);
